import { PageNumberPagination } from '@/interfaces/common/PageNumberPagination'
import ApiService from '@/plugins/api-plugin/services/api.service'
import {
    MonitorEventDao,
    MonitorEventIdsDao,
    MonitorEventsQuery,
    MonitorMessageQueueDao,
    MonitorReleaseResultDao,
    MonitorRuleDetailDao,
    MonitorRuleGroupDao,
    MonitorSummaryDao,
    MonitorWindowQuery,
    RetryConfigDao,
} from '@/interfaces/system-events-monitor/SystemEventsMonitor.dao'

const BASE = '/system-events/monitor'

export default class SystemEventsMonitorService extends ApiService {
    async getSummary(query: MonitorWindowQuery): Promise<MonitorSummaryDao | null> {
        return this.request<undefined, MonitorSummaryDao>(
            'GET',
            `${BASE}/summary`,
            { ...query },
            undefined,
            undefined,
            'getMonitorSummary',
        ).catch(() => null)
    }

    async getRuleGroups(query: MonitorWindowQuery): Promise<MonitorRuleGroupDao[] | null> {
        return this.request<undefined, MonitorRuleGroupDao[]>(
            'GET',
            `${BASE}/rules`,
            { ...query },
            undefined,
            undefined,
            'getMonitorRuleGroups',
        ).catch(() => null)
    }

    async getRuleDetail(ruleId: number): Promise<MonitorRuleDetailDao | null> {
        return this.request<undefined, MonitorRuleDetailDao>(
            'GET',
            `${BASE}/rules/${ruleId}`,
            undefined,
            undefined,
            undefined,
            'getMonitorRuleDetail',
        ).catch(() => null)
    }

    async getRuleEvents(
        ruleId: number,
        query: MonitorEventsQuery,
    ): Promise<[MonitorEventDao[], PageNumberPagination] | null> {
        return this.request<undefined, [MonitorEventDao[], PageNumberPagination]>(
            'GET',
            `${BASE}/rules/${ruleId}/events`,
            { ...query },
            undefined,
            undefined,
            'getMonitorRuleEvents',
        ).catch(() => null)
    }

    async getRuleEventIds(ruleId: number, query: MonitorEventsQuery): Promise<MonitorEventIdsDao | null> {
        return this.request<undefined, MonitorEventIdsDao>(
            'GET',
            `${BASE}/rules/${ruleId}/event-ids`,
            { ...query },
            undefined,
            undefined,
            'getMonitorRuleEventIds',
        ).catch(() => null)
    }

    async getMessageQueue(eventId: number): Promise<MonitorMessageQueueDao | null> {
        return this.request<undefined, MonitorMessageQueueDao>(
            'GET',
            `${BASE}/events/${eventId}/message-queue`,
            undefined,
            undefined,
            undefined,
            'getMonitorMessageQueue',
        ).catch(() => null)
    }

    async release(eventIds: number[]): Promise<MonitorReleaseResultDao | null> {
        return this.request<{ eventIds: number[] }, MonitorReleaseResultDao>(
            'POST',
            `${BASE}/release`,
            undefined,
            { eventIds },
            undefined,
            'releaseMonitorEvents',
        ).catch(() => null)
    }

    async updateRetryConfig(ruleId: number, config: RetryConfigDao): Promise<MonitorRuleDetailDao | null> {
        return this.request<RetryConfigDao, MonitorRuleDetailDao>(
            'PATCH',
            `${BASE}/rules/${ruleId}/retry-config`,
            undefined,
            config,
            undefined,
            'updateMonitorRetryConfig',
        ).catch(() => null)
    }
}
